import { useCallback } from "react";
import { useCreateCustomCategoryMutation } from "../../../api/category.api";
import { CategoryForm } from "./CategoryForm";

interface CategorySchema {
    label: string;
    description: string | null;
}

export const CreateCategoryModal = ({
    parentCategoryId,
    onHide,
}: {
    onHide: () => void;
    parentCategoryId: string;
}) => {
    const createMutation = useCreateCustomCategoryMutation();

    const onSubmit = useCallback(
        (categoryData: CategorySchema) =>
            createMutation.mutateAsync({
                description: categoryData.description ?? null,
                label: categoryData.label,
                parentCategoryId,
            }),
        [createMutation, parentCategoryId],
    );

    return (
        <CategoryForm
            onHide={onHide}
            onSubmitCategory={onSubmit}
            isPending={createMutation.isPending}
        />
    );
};
